'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var alternativePpButtons = document.querySelectorAll('.alternative-pp .alternative-pp-button');
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = alternativePpButtons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var button = _step.value;

            button.addEventListener('click', alternativePpButtonClick);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    function alternativePpButtonClick(event) {
        var button = event.target;

        var url = button.classList.contains('alternative-pp-confirm') ? 'ApprovePpChangeRequest' : 'DeclinePpChangeRequest';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', url);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('X-XSRF-TOKEN', getCookie('XSRF-TOKEN'));
        xhr.onreadystatechange = function () {
            alternativePpStateChangeDone(xhr);
        };

        var sentBody = JSON.stringify({ id: button.dataset.alternativePpId });
        xhr.send(sentBody);
    }

    function alternativePpStateChangeDone(xhr) {
        if (!xhr || xhr.readyState !== 4) return;

        var returnObject = JSON.parse(xhr.response);
        if (returnObject.success && returnObject.result.isSuccess) {
            _notify2.default.success(returnObject.result.message);
            $("#zasilkovnaChangesTable").DataTable().ajax.reload(null, false);
        } else {
            _notify2.default.error(Resx.App.ErrorsWhileSaving);
            console.error(returnObject.result.message);
        }
    }
};

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/Initializers/alternativePp.js
// module id = 408
// module chunks = 0